import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import type { AuthState } from '../types/redux.types'

const initialState: AuthState = {
  user: null
}

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setCredentials: (state, action: PayloadAction<AuthState['user']>) => {
      state.user = action.payload
    },
    logOut: (state) => {
      state.user = null
    },
  },
})

export const { setCredentials, logOut } = authSlice.actions

export default authSlice.reducer

export const selectCurrentUser = (state: { auth: AuthState }) => state.auth.user
